<template>
  <v-container fluid />
</template>

<script>
export default {
  name: "Modules",
  mounted() {
    window.location.replace("/app/modules");
  },
};
</script>
